import PlanCategories from "@/mixins/PlanCategories.js";

const tripCategoriesAllowed = [
  PlanCategories.TRIP.ID,
  PlanCategories.CRUISE.ID,
  PlanCategories.CFAR.ID,
  29, // Flight Accident Insurance — uses trip-style plan cards
];

export default tripCategoriesAllowed;
